import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { loadInvestmentTypes } from '../../../../actions/actionCreators'
import ReactHTMLDatalist from 'react-html-datalist'
import { selectInvestmentTypeFilter } from '../../../../actions/actions'

export default function InvestmentTypesSelect () {
  const [name, setName] = useState('')

  const dispatch = useDispatch()
  const investmentTypes = useSelector(({ investmentTypes }) => investmentTypes.investmentTypes, shallowEqual)

  const newOption = investmentType => {
    return {
      text: investmentType.name, value: investmentType.id
    }
  }
  const newInvestmentType = option => {
    return {
      name: option.text, id: option.value
    }
  }

  useEffect(() => {
    dispatch(loadInvestmentTypes(name))
  }, [dispatch, name])

  const handleChange = e => {
    if (e.target.value === '') {
      setName(e.target.text)
      return
    }
    dispatch(selectInvestmentTypeFilter(newInvestmentType(e.target)))
  }
  return (
    <>
      <label htmlFor='investmentType-input' className='col-md-1 col-form-label'>Invest. Type</label>
      <div className='col-md-3'>
        <ReactHTMLDatalist
          name='investmentType_id'
          onChange={handleChange}
          classNames='form-control'
          options={investmentTypes.map(newOption)}
        />
      </div>
    </>
  )
}
